export default "__VITE_ASSET__CaL9rR5K__"